import peptLogo from '../assets/pept-logo.png';

// Vial Mockup Display for Product Page - Shows real image if available, logo fallback otherwise
export const VialMockupDisplay = ({ productName, imageUrl = null }) => {
  // If we have a real image, show it
  if (imageUrl) {
    return (
      <div className="bg-gradient-to-b from-slate-50 to-slate-100 border border-neutral-200 rounded-sm p-8" data-testid="vial-mockup-display">
        <div className="flex flex-col items-center">
          <img 
            src={imageUrl} 
            alt={`${productName} vial`}
            className="max-h-[400px] w-auto object-contain rounded-sm"
            onError={(e) => {
              // Fallback to logo if image fails to load
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className="hidden flex-col items-center" style={{ display: 'none' }}>
            <LogoFallback />
          </div>
          <p className="text-xs text-neutral-500 mt-6 text-center">
            Actual product vial
          </p>
        </div>
      </div>
    );
  }

  // Fallback to logo
  return (
    <div className="bg-gradient-to-b from-slate-50 to-slate-100 border border-neutral-200 rounded-sm p-8" data-testid="vial-mockup-display">
      <div className="flex flex-col items-center">
        <LogoFallback />
      </div>
    </div>
  );
};

// Simple logo fallback when no vial image is available
const LogoFallback = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <img 
        src={peptLogo} 
        alt="PEP-T.COM" 
        className="w-48 h-auto object-contain opacity-80"
      />
      <p className="text-xs text-neutral-400 mt-4 text-center">
        Product image coming soon
      </p>
    </div>
  );
};
